import React, { useEffect, useContext } from 'react'
import { URL_S3 } from '../../../../config/BaseUrl'
import '../styles/GifTabs.scss'
import Sidebar from './Sidebar'
import CanvasEditor from '../../../../components/CanvasEditor'
import { EditorContext } from '../../../../components/CanvasEditor/Context/EditorProvider'

const GIFEditTabs = ({item, closeItem}) => {

  useEffect(()=>{
    window.scroll(0,0)
  },[])

  const { onReady, download } = useContext(EditorContext)

  const downloadCanvas = () => {
    download()
  }


  return (
    <div className='Gif-edit-tabs'>
      <div className='gif-edit-container'>
        <div className='row justify-content-center'>
          <div className='col-md-8 text-center mt-5'>
            <button className='rounded-pill mr-2 btn btn-outline-primary' type='button'>Save</button>
            <button className='rounded-pill mr-2 btn btn-outline-primary' type='button'>Reset</button>
            <button className='rounded-pill mr-2 btn btn-outline-primary' type='button'>Help</button>
            <button className='rounded-pill mr-2 btn btn-outline-primary' type='button' onClick={downloadCanvas}>Download</button>
            <button className='rounded-pill mr-2 btn btn-outline-primary' type='button'>Upload</button>
            <button className='rounded-pill btn btn-outline-danger' type='button' onClick={e=> closeItem()}>Cancel</button>
          </div>
          <div className='col-md-12'>
            <div className='edit-section mt-4'>
              <div className='d-flex'>
                <Sidebar />
                <div className='edit-panel'>
                  <CanvasEditor 
                    classList={'edit-panel-body'} 
                    backgroundImage={`${URL_S3}image/gif/${item.photo}`} 
                    onReady={onReady} 
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default GIFEditTabs